import { Component, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatIconButton } from '@angular/material/button';
import { UpperCasePipe } from '@angular/common';

@Component({
    selector: 'app-language-toggler',
    styles: [`
    button {
     height: 48px;
     width: 48px !important;
    }

    .text-size-default {
        font-size: 14px;
        line-height: 1.428;
    }

    .text-size-default:hover {
        color: #847cff !important;
        transition: color .7s ease-in-out;
    }

    .nav-link-light {
	    color: var(--text-light-gray) !important
    }`
    ],
    template: `
    <button mat-icon-button (click)="toggleLanguage()" class="text-size-default nav-link-light">{{ lang | uppercase }}</button>
  `,
    imports: [MatIconButton, UpperCasePipe]
})
export class LanguageTogglerComponent implements OnInit {
  private translateSvc = inject(TranslateService);

  lang!: string;

  ngOnInit(): void {
    this.lang = this.translateSvc.currentLang ?? 'en'
  }

  toggleLanguage() {
    this.lang = this.lang === 'en' ? 'it' : 'en';
    this.translateSvc.use(this.lang);
  }
}
